import { render, staticRenderFns } from "./kyc.vue?vue&type=template&id=6a5643ca&scoped=true&"
import script from "./kyc.vue?vue&type=script&lang=js&"
export * from "./kyc.vue?vue&type=script&lang=js&"
import style0 from "./kyc.vue?vue&type=style&index=0&id=6a5643ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5643ca",
  null
  
)

export default component.exports